module.exports = __webpack_public_path__ + "static/media/4 dark art surrealism nun evil demon blackwork.1280x1447.0c89aadd.webp";